<template>

<core-modal v-on:close="onClose" :nopadding="true" icon="caret-left">

	<template v-slot:head>

		<span>Settings</span>

		<small>{{ view.name }}</small>

	</template>

	<template v-slot:default>

        <core-modal-inputs>

            <core-input-textbox v-model="model.name" placeholder="Enter name" />

        </core-modal-inputs>

		<com-type v-model="model.type" :is-locked="true" />
		<com-public v-model="model.public" />

	</template>

	<template v-slot:foot>

		<core-button theme="blue" :loading="is.loading" :disabled="!model.name" v-on:click.native="onConfirmClick">Save changes</core-button>
		<core-button theme="red" v-on:click.native="onRemoveClick">Delete</core-button>

	</template>

</core-modal>

</template>

<script>

import mixValidation from 'core/mixin/modal/Validation'

import comType from './create/Type'
import comPublic from './create/Public'

export default {

	mixins: [mixValidation],

	props: ['data'],

    components: {
        comType,
        comPublic
    },

	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

    created: function() {

        this.$vueset(this, 'model', this.$util.copy(this.$store.getters['data/views/associated'][this.data.view]))

    },

	computed: {

        view: function() {

            return this.$_.find(this.$store.getters['data/views/list'], function(view) {

                return view.id === this.data.view

            }.bind(this))

        }

	},

	methods: {

        onConfirmClick: function() {

			this.is.loading = true

            this.$api.post('views/view/save', {
				model: this.model
			}).then(function(response) {

				this.$store.commit('data/views/update', [response])

				this.$emit('close')

				this.$pubsub.$emit('open.modal', {
			    	id: 'viewsView',
                    view: this.data.view
				})

			}.bind(this), function() {

				this.is.error = true
				this.is.loading = false

			}.bind(this)) 	

        },

        onRemoveClick: function() {

            this.$pubsub.$emit('open.modal', {
				id: 'viewsViewDelete',
                view: this.data.view
			})

			this.$emit('close')
        },

		onClose: function() {

            this.$pubsub.$emit('open.modal', {
				id: 'viewsView',
                view: this.data.view
			})

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

</style>